export default __webpack_public_path__ + "static/media/default-card-image-ALPHA.96d928af.jpg";